import { render } from "./InputComponent.vue?vue&type=template&id=22b9091f"
import script from "./InputComponent.vue?vue&type=script&lang=js"
export * from "./InputComponent.vue?vue&type=script&lang=js"
script.render = render

export default script